module.exports = __webpack_public_path__ + "static/img/team_honor_yajun.9fbf9104.png";